import React, { Component } from 'react';
import './Deals.css';
import {DealItem} from './DealItem'
import SimpleSlider from '../SimpleSlider/SimpleSlider';
import { Img } from '../UI/UI';
import { getImgUrl , limitText } from "../../Utility/Utility"


class Deals extends Component {
  
  constructor (props){
  	super(props);
  	this.image_url = getImgUrl();
  	
  	this.dealsSliderSettings = {
      	dots: true,
      	infinite: true,
      	cssEase: 'linear',
      	autoplay:true,
      	lazyLoad: "ondemand",
      	slidesToShow: (this.props.items != undefined  ) ? this.props.items : 3,
		slidesToScroll: 1,
		responsive: [
	        {
	          breakpoint: 1000,
	          settings: {
	            slidesToShow: 2,
	            slidesToScroll: 2
	          }
	        },
	        {
	          breakpoint: 600,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }
      	]
    };

  	  	this.deals = [

  	  	            {

  	  		   lang: 'uk',
  	  		   deals: [


							{
								title: "easyJet Holidays",
								desc : "Jerusalem City Break - 4 Nights at 4* Prima Palace r/o, inc flights from Luton with checked bag, based on 2 people sharing" ,
								price : "£439" ,
								logo: "/Deals/en/new/easyjetHolidays.jpg" ,
								link : "https://www.easyjet.com/en/holidays/israel/jerusalem/jerusalem/prima-palace?ibf=true&to=19-05-2022&from=15-05-2022&dst=X9061499&geog=&sAccId=X9061499&flex=1&org%5b0%5d=LGW&org%5b1%5d=LTN&aa=1&rooms%5b0%5d%5badults%5d=2&rooms%5b0%5d%5bchildren%5d=0&rooms%5b0%5d%5binfants%5d=0&outId=E2b16dd78fad3e7de755466079170a685&inId=E51c900aaf0529f9d0a72dda1d7ead311&accId=X9061499&packId=2151481941/2/1622/4&offerCode=X9061499_2151481941%2F2%2F1622%2F4_DBT.OM!NOR.BAR%20RO%20NIS%20MS4N-RO&boardType=RO&offerRooms%5b0%5d%5badults%5d=2&offerRooms%5b0%5d%5bchildren%5d=0&offerRooms%5b0%5d%5binfants%5d=0&offerRooms%5b0%5d%5broomCode%5d=DBT.OM!NOR.BAR%20RO%20NIS%20MS4N&transfer=&dtransfer=&isExt=1&lateRoomCheckout=0&otherRoutes=&theme=city" ,
								book_now : "BOOK NOW"
							},
							{
								title: "West End Travel",
								desc : "Tel Aviv City Break - 3-night weekend break on B&B basis, based on 2 sharing" ,
								price : "£599" ,
								logo: "/Deals/en/new/westendtravel.jpg" ,
								link : "http://www.westendtravel.co.uk/israel/tel-aviv/" ,
								book_now : "BOOK NOW"
							},
							{
								title: "Superstar Holidays",
								desc : "Tel Aviv City Break - 3-night break at 4* hotel on B&B basis, based on 2 sharing" ,
								price : "£698" ,
								logo: "/Deals/en/new/superstarholiday.jpg" ,
								link : "https://www.elal.com/en/UK/Superstar-Holidays/Pages/CityBreak-May.aspx#" ,
								book_now : "BOOK NOW"
							},
							{
								title: "Travel Israel",
								desc : "Jerusalem City Break: 4-night r/o staying at YMCA 3 Arches Hotel inc. BA flights from Heathrow, based on 2  people sharing" ,
								price : "£698" ,
								logo: "/Deals/en/new/travelisrael.jpg" ,
								link : "https://www.travelisrael.co.uk/jerusalem" ,
								book_now : "BOOK NOW"
							},
							{
								title: "Cyplon Holidays",
								desc : "Israel Highlights Escorted Tour: 7-night B&B visiting Israel's most iconic sites, based on 2 sharing" ,
								price : "£1,469" ,
								logo: "/Deals/en/new/cyplon.jpg" ,
								link : "https://www.cyplon.co.uk/holidays/israel/guided-tours/israel-highlights-tour" ,
								book_now : "BOOK NOW"
							},
							{
								title: "Leger Holidays",
								desc : "Israel Highlights Escorted Tour: 7-night B&B visiting Israel's most iconic sites, based on 2 sharing" ,
								price : "£1,799" ,
								logo: "/Deals/en/new/layerholidays.jpg" ,
								link : "https://www.cyplon.co.uk/holidays/israel/guided-tours/israel-highlights-tour" ,
								book_now : "BOOK NOW"
							},

							
				    ]

  	  	},

  	  	{

  	  		   lang: 'cz',
  	  		   deals: [


						{
							title: "EXPEDIA",
							desc : " Velké množství levných letenek do Tel Avivu od 4,538 Kč",
							price : "4,538 Kč" ,
							logo: "/Deals/cz/25.jpg" ,
							link : "https://www.expedia.com/lp/flights/prg/tlv/prague-to-tel-aviv" ,
							css_class: "unic-deal-444",
							book_now : "Rezervujte nyní "
						},
						
						{
							title: "El Al",
							desc : " Velké množství levných letenek do Tel Avivu od 4,822 Kč",
							price : "4,822 Kč" ,
							logo: "/Deals/cz/35.jpg" ,
							link : "https://www.elal.com/en/OtherCountries/Pages/default.aspx" ,
							css_class: "unic-deal-333",
							book_now : "Rezervujte nyní "
						},
						
						{
							title: "EXPEDIA",
							desc : "4 noci včetně hotelu a letenek od 5,785 Kč",
							price : "5,785 Kč" ,
							logo: "/Deals/cz/25.jpg" ,
							link : "https://www.expedia.com/Hotel-Search?packageType=fh&searchProduct=hotel&c=7b6c263d-361d-4ef5-8e30-36843fd6e1be&rfrr=PKG.FH.HSR.Refine.Date&adults=2&originId=4674128&ftla=PRG&destination=Tel+Aviv+(and+vicinity),+Israel&destinationId=180031&ttla=TLV&startDate=1/9/2020&endDate=1/12/2020&sort=recommended&tripType=ROUND_TRIP&misId=f4a521b1-4bbc-428f-add4-abdb09bd9c1a" ,
							css_class: "unic-deal-555",
							book_now : "Rezervujte nyní "
						},

						{
							title: "Czech airlines",
							desc : " Velké množství levných letenek do Tel Avivu od 6,787 Kč",
							price : "6,787 Kč" ,
							logo: "/Deals/cz/36.jpg" ,
							link : "https://www.csa.cz/cz-cs/rezervovat/dest-TLV/dep-PRG/" ,
							css_class: "unic-deal-222",
							book_now : "Rezervujte nyní "
						},

						{
							title: "Tel Aviv",
							desc : " Víkend ve městě krásných pláží, promenád a romantických uliček.",
							price : "17,380 Kč" ,
							logo  : "/Deals/cz/91.png" ,
							link : "http://www.karetatour.cz/zajezdy/izrael/tel-aviv-olympia-3-vikend-410913/" ,
							css_class: "unic-deal-223",
							book_now : "Rezervujte nyní "
						},
						{
							title: "Čedok a.s.",
							desc : "roundtrips",
							price : "20,019 Kč" ,
							logo  : "/Deals/cz/37.jpg" ,
							link : "https://www.cedok.cz/zajezdy/egypt/ve-stinu-olivovniku-to-je-izrael,TCP2IZR.html?ofr_id=bba939a790c14ef437e1235ff9565058993e0b34035811a8b20b33882b0bf858&adults=2&childs=0" ,
							css_class: "unic-deal-23990",
							book_now : "Rezervujte nyní "
						},

						{
							title: "Jeruzalém",
							desc : " Prodloužený víkend v jednom z nejstarších měst světa.",
							price : "22,830 Kč" ,
							logo  : "/Deals/cz/91.png" ,
							link : "http://www.karetatour.cz/zajezdy/izrael/jeruzalem-grand-court-4-vikend-419828/" ,
							css_class: "unic-deal-224",
							book_now : "Rezervujte nyní "
						},
						{
							title: "Tel-Aviv Hotels",
							desc : "Objevte Tel Aviv City Break Večeře pro dva zdarma",
							price : "3,100 Kč" ,
							logo  : "/Deals/cz/tlv-hotels.png" ,
							link : "https://www.visit-tel-aviv.com/en/promotions/telaviv" ,
							css_class: "unic-deal-333222",
							book_now : "Rezervujte nyní "
						},

					    {
							title: "Čedok a.s.",
							desc : "Prodloužený víkend v Jeruzalémě / To nejlepší z Izraele /  Izrael – Jordánsko a koupání u Mrtvého moře",
							price : "23,990 Kč" ,
							logo  :"/Deals/cz/37.jpg" ,
							link : "https://www.cedok.cz/zajezdy/izrael/tel-aviv/prodlouzeny-vikend-v-jeruzaleme,8437.html?ofr_id=fc2f6837b17ce541e2c0d3e056c7bdc8225ad7ae8fff68be512bb59e0cb7882d&adults=2&childs=0" ,
							css_class: "unic-deal-666",
							book_now : "Rezervujte nyní "
						},
						{
							title: "Čedok a.s.",
							desc : "citybreaks",
							price : "23,990 Kč" ,
							logo: "/Deals/cz/37.jpg" ,
							link : "https://www.cedok.cz/zajezdy/izrael/tel-aviv/prodlouzeny-vikend-v-jeruzaleme,TLV2402.html?ofr_id=c6298f452d62ae7ed860980841267a9efb29e9dff77fbf6402b0de11981638f2&adults=2&childs=0" ,
							css_class: "unic-deal-23990",
							book_now : "Rezervujte nyní "
						}
				    ]

  	  	},

  	  	{

  	  		   lang: 'ro',
  	  		   deals: [


							{
						      title : "Blue Air",
						      agent : "Blue_Air",
						      desc : "Zboruri directe din Bucuresti si Cluj-Napoca catre Tel Aviv incepand de la 38 €. In plus, iti oferim gratuit sandwich, bauturi racoritoare, apa si cafea pe timpul zborului. Incepe calatoria catre capitala petrecerilor!",
						      price : "38 €",
						      logo: "Deals/ro/BlueAir.jpg",
						      link:"https://goo.gl/LsNsvB",
						      css_class: "unic-deal-10",
						      book_now:"REZERVAȚI ACUM"
						      },

						    {
						      title : "Ryanair",
						      agent : "Ryanair",
						      desc : "O gamă variată de zboruri ieftine la Tel Aviv începând de la 50 €",
						      price : "50 €",
						      logo: "Deals/ro/rainer.jpg",
						      link:"https://www.ryanair.com/gb/en/cheap-flights/Bucharest-Otopeni-to-tel-aviv?out-from-date=2019-07-29&out-to-date=2020-07-29&budget=150",
						      css_class:"unic-deal-50",
						      book_now:"REZERVAȚI ACUM"
						    },
							{
								title : "EXIMTUR",
								agent : "EXIMTUR",
								desc : "Black Friday la zeci de hoteluri din Ierusalim sau Tel Aviv pentru rezervari efectuate pana la 30.11.",
								price : "60 €",
								logo: "Deals/ro/9b.jpg",
								link:"https://www.eximtur.ro/hotel/Jerusalem-485115-7697?rel=boxes",
								css_class: "unic-deal-EXIMTUR deal-black-friday",
								book_now:"REZERVAȚI ACUM"
							},
						     {
						      title : "Wizzair",
						      agent : "Wizzair",
						      desc : " Super ofertă: O gamă variată de zboruri ieftine de la București, Cluj-Napoca, CRAIOVA la Tel Aviv începând de la 63 €",
						      price : "63 €",
						      logo: "Deals/ro/26.png",
						      link:"https://wizzair.com/ro-ro/zboruri/program-zboruri/clujnapoca/telaviv#/0/0/1/0/0/2018-11/2018-12",
						      css_class: "unic-deal-1",
						      book_now:"REZERVAȚI ACUM"
						      },
						      {
						          title : "VELTRAVEL.RO",
						          agent : "VELTRAVEL.RO",
						          desc : "Cu VelTravel va puteti construi singuri propria vacanta in Tel Aviv. Avion + cazare 3 nopti in Tel Aviv de la 142 € ",
						          price : "142 €",
						          logo: "Deals/ro/9b.png",
						          link:"https://www.veltravel.ro/oferte-avion-cazare-tel-aviv-3477-o/",
						          css_class: "unic-deal-13",
						          book_now:"REZERVAȚI ACUM"
						      },
						      {
								  title : "COCKTAIL HOLIDAYS",
								  agent : "COCKTAIL_HOLIDAYS",
								  desc : "bilet de avion si cazare 3 nopti cu mic dejun",
								  price : "184 €",
								  logo: "Deals/ro/32.png",
								  link:"https://shop.cocktailholidays.ro/vacante-israel/",
								  css_class: "unic-deal-COCKTAIL_HOLIDAYS",
								  book_now:"REZERVAȚI ACUM"
							  },
						      {
								  title: "4U Travel",
								  agent: "4U_Travel",
								  desc : "Exploreaza Ierusalim, Orasul Sfant: 2 nopti cazare, cu mic dejun, avion cu bagaj de mana si toate taxele de aeroport incluse, de la 185 euro/persoana",
								  price : "185 €",
								  logo: "Deals/ro/37.jpg",
								  link : "http://vacante-exotice.ro/hotel/city-break-ierusalim/",
								  book_now : "REZERVAȚI ACUM"
							  },

							  {
								  title: "4U Travel",
								  agent: "4U_Travel",
								  desc : "City break la Tel Aviv: 2 nopti cazare la hotel 4*, cu mic dejun, avion cu bagaj de mana si toate taxele de aeroport incluse, de la 195 euro/persoana",
								  price : "195 €",
								  logo: "Deals/ro/37.jpg",
								  link : "http://vacante-exotice.ro/hotel/city-break-tel-aviv/",
								  book_now : "REZERVAȚI ACUM"
							  },
							  {
							      title : "El Al",
							      agent : "El_Al",
							      desc : "Petreceți un weekend relaxant în Tel Aviv",
							      price : "214 €",
							      logo: "Deals/ro/elal.png",
							      link:"https://www.elal.com/en/Romania/Pages/default.aspx",
							      css_class: "unic-deal-7",
							      book_now:"REZERVAȚI ACUM"
						      },

						      {
							      title : "Hotelurile din Tel Aviv",
							      agent : "Hotelurile_din_Tel_Aviv",
							      desc : "Descoperiți sejurul în Tel Aviv Cină gratis pentru două persoane",
							      price : "120 €",
							      logo: "Deals/ro/tlv-hotels.png",
							      link:"https://www.visit-tel-aviv.com/en/promotions/telaviv",
							      css_class: "unic-deal-30",
							      book_now:"REZERVAȚI ACUM"
						      },
						     
						      

						      {
						          title : "Tarom",
						          agent : "Tarom",
						          desc : " O gamă variată de zboruri ieftine de la București la Tel Aviv începând de la 261 €",
						          price : "261 €",
						          logo: "Deals/ro/33.png",
						          link:"https://www.tarom.ro/en/tel-aviv",
						          css_class: "unic-deal-9",
						          book_now:"REZERVAȚI ACUM"
						      },

						      {
						          title : "THEOREMA Travel",
						          agent : "THEOREMA_Travel",
						          desc : "Super ofertă: Fantastic Jerusalem! Bucura-te de 3 nopti cazare cu mic dejun inclus si zbor direct din Bucuresti, Cluj, Craiova, Iasi si Timisoara.",
						          price : "265 €",
						          logo: "Deals/ro/18.jpg",
						          link:"http://www.theorematravel.ro/israel",
						          css_class: "unic-deal-2",
						          book_now:"REZERVAȚI ACUM"
						      },

						      {
							      title : "COCKTAIL HOLIDAYS",
							      agent : "COCKTAIL_HOLIDAYS",
							      desc : "City Break avion WIZZ AIR cu TOATE TAXELE INCLUSE! Descopera Tel Aviv, orasul care nu doarme: 3 nopti cazare cu mic dejun, transport avion, zbor, bagaj de mana.",
							      price : "266 €",
							      logo: "Deals/ro/32.png",
							      link:"http://www.cocktailholidays.ro/sejururi/10/orientul+mijlociu/israel/&localitate=tel+aviv",
							      css_class: "unic-deal-7",
							      book_now:"REZERVAȚI ACUM"
						      },

						      {
								  title : "Tourex",
								  agent : "Tourex",
								  desc : "Preturi incepand cu 275 eur/pers - avion si 3 nopti cazare cu mic-dejun inclus.",
								  price : "275 €",
								  logo: "Deals/ro/Tourex.jpg",
								  link:"http://tourex.ro/israel/",
								  css_class: "unic-deal-Tourex deal-black-friday",
								  book_now:"REZERVAȚI ACUM"
							  },

							  {
							      title : "THEOREMA Travel",
							      agent : "THEOREMA_Travel",
							      desc : "Super ofertă: Fantastic Tel Aviv! Bucura-te de 3 nopti cazare cu mic dejun inclus si zbor direct din Bucuresti, Cluj, Craiova, Iasi si Timisoara.",
							      price : "290 €",
							      logo: "Deals/ro/18.jpg",
							      link:"http://www.theorematravel.ro/israel",
							      css_class: "unic-deal-3",
							      book_now:"REZERVAȚI ACUM"
						      },

						     
						      {
							      title : "EXIMTUR",
							      agent : "EXIMTUR",
							      desc : "Călătorește cu stil la Tel Aviv! 3 nopti de cazare în cameră dublă, hotel de 4*, mic dejun și bilet de avion incluse. Plecări din București, Cluj și Timișoara",
							      price : "335 €",
							      logo: "Deals/ro/9b.jpg",
							      link:"https://www.eximtur.ro/hotel/Tel+Aviv-485075-7697/HOTEL+75-450608?VacationType=individual&rel=boxes",
							      css_class: "unic-deal-12",
							      book_now:"REZERVAȚI ACUM"
						      },

							  

						       {
							      title : "COCKTAIL HOLIDAYS",
							      agent : "COCKTAIL_HOLIDAYS",
							      desc : "City Break avion TAROM cu TOATE TAXELE INCLUSE! Descopera fascinatia Orasului de Aur: Cazare 1 noapte Ierusalim & 2 nopti Tel Aviv, Mic Dejun, zbor, bagaj de mana + cala INCLUS.",
							      price : "344 €",
							      logo: "Deals/ro/32.png",
							      link:"http://www.cocktailholidays.ro/sejururi/10/orientul+mijlociu/israel/&localitate=jerusalem",
							      css_class: "unic-deal-8",
							      book_now:"REZERVAȚI ACUM"
						      },
						      {
							      title : "Europa Travel",
							      agent : "Europa_Travel",
							      desc : "City Break in insoritul Tel Aviv, de la 369 euro/persoana, cazare la hotel de 3 stele.",
							      price : "369€",
							      logo: "Deals/ro/26.jpg",
							      link:"https://europatravel.ro/citybreak/oferta/city-break-avion-tel-aviv-israel/905",
							      css_class: "unic-deal-369",
							      book_now:"REZERVAȚI ACUM"
							  },
						      {
								  title : "Tourex",
								  agent : "Tourex",
								  desc : "Preturi incepand de la 379 eur bilet de avion, 4 nopti cazare in camera dubla si mic dejun",
								  price : "379 €",
								  logo: "Deals/ro/Tourex.jpg",
								  link:"http://tourex.ro/israel/",
								  css_class: "unic-deal-2",
								  book_now:"REZERVAȚI ACUM"
							  },
						      {
							      title : "Europa Travel",
							      agent : "Europa_Travel",
							      desc : "Shop and fun in Israel? Combini distractia si relaxarea de pe plajele fabuloase din Tel Aviv cu sedinte de shopping pe celebra strada Ben Yehuna.",
							      price : "399€",
							      logo: "Deals/ro/26.jpg",
							      link:"https://europatravel.ro/circuite/oferta/shop-and-club-israel/773/israel",
							      css_class: "unic-deal-399",
							      book_now:"REZERVAȚI ACUM"
						      },
				    ]

  	  	},

  	  	{

  	  		   lang: 'dk',
  	  		   deals: [


							  {
						        title: "Norwegian",
						        desc: "Billige fly fra Køpenhavn til Tel Aviv",
						        price : "1638 DKK",
						        logo: "Deals/dk/9.png",
						        link: "https://www.norwegian.com/dk/destinationer/tel-aviv",
						        css_class: "unic-deal-1638",
						        book_now: "Book nu"
						      },
						      
						      
						      {
						        title: "Spies",
						        desc: "Tel Aviv weekend, fly t&r og ophold 3 nætter inkl. Morgenmad",
						        price : "3204  DKK",
						        logo: "Deals/dk/11.png",
						        link: "https://www.spies.dk/israel/tel-aviv",
						        css_class: "unic-deal-3204",
						        book_now: "Book nu"
						      },

						      {
						        title: "Solfaktor",
						        desc: "Fly + Dobbeltværelse & morgenmad",
						        price : "3399 DKK ",
						        logo: "Deals/dk/4.jpg",
						        css_class: "unic-deal-3399",
						        link: "https://www.solfaktor.dk/tour/charters?deps=Danmark&deps_tree=&deps_expanded=&words=+Tel+Aviv&search_geo=&search_tree=&search_expanded=&delta=21&days=3-3&rating=13&beds=0&maxprce=&beach=&centre=&comp=nosfp&comp=dksfp&comp=dksc&comp=sesfp&comp=sesc&comp=nosc",
						        book_now: "Book nu"
						      },
						      
						      {
						        title: "Travelstart",
						        desc: "Fly + tre nætter i Tel Aviv ",
						        price : "4280 DKK",
						        logo: "Deals/dk/7.jpg",
						        css_class: "unic-deal-4280",
						        link: "https://www.travelstart.dk/billige-fly/israel",
						        book_now: "Book nu"
						      },

						      {
						        title: "Likiso",
						        desc: "Direktefly + tre nætter i Tel Aviv",
						        price : "4511 DKK",
						        logo: "Deals/dk/2.jpg",
						        css_class: "unic-deal-4511",
						        link: "https://www.likiso.com/da/fly-og-hoteller-til-tel-aviv",
						        book_now: "Book nu"
						      },

						      {
						        title: "Tel-Aviv Hotels",
						        desc: "Udforsk Tel Aviv City Break Middag for to uden beregning",
						        price : "900 DKK",
						        logo: "Deals/dk/tlv-hotels.png",
						        css_class: "unic-deal-900",
						        link: "https://www.visit-tel-aviv.com/en/promotions/telaviv",
						        book_now: "Book nu"
						      },

						      // {
						      //   title: "Tikva Travel",
						      //   desc: "4 nætter på 3* hotel i Tel Aviv",
						      //   price : " 5200 DKK",
						      //   logo: "Deals/dk/10.png",
						      //   css_class: "unic-deal-5200",
						      //   link: "https://www.tikva-travel.dk/israel/",
						      //   book_now: "Book nu"
						      // },

						      // {
						      //   title: "El Al",
						      //   desc: "Nyd en afslappende weekend i Tel Aviv",
						      //   price : "5950 DKK",
						      //   logo: "Deals/dk/elal.png",
						      //   css_class: "unic-deal-5950",
						      //   link: "https://www.elal.com/en/OtherCountries/Pages/default.aspx",
						      //   book_now: "Book nu"
						      // },

						      

						      {
						        title: "Kulturrejser Europa",
						        desc: "TEL AVIV CITY BREAK PAKKE",
						        price : "7495 DKK",
						        logo: "Deals/dk/Kulturrejser.jpg",
						        css_class: "unic-deal-7495",
						        link: "https://www.kulturrejser-europa.dk/israel/tel-aviv-city-break-to-byer-i-en-miniferie",
						        book_now: "Book nu"
						      },

						      // {
						      //   title: "Kulturrejser Europa",
						      //   desc: "5 dagar, sv reseledare, stadstur i Tel Aviv, utflykt till Jerusalem. Direktflyg, transfer, centralt boutiquehotell, frukost.",
						      //   price : "11.400 DKK",
						      //   logo: "Deals/dk/Kulturrejser.jpg",
						      //   css_class: "unic-deal-11400",
						      //   link: "https://eur01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.kulturresor-europa.se%2Fisrael%2Ftel-aviv-city-break&data=02%7C01%7Cdirector-se%40goisrael.gov.il%7C15919778b06e490e79c608d75be2078e%7Ce5a1a45ba59f44db8fa1d979ba86371b%7C1%7C0%7C637078899225359675&sdata=xB%2BkcAULPu4RSAlyr3ovRsyBsj%2BFq%2BD6M2WBo3w9qOU%3D&reserved=0",
						      //   book_now: "Book nu"
						      // },
				    ]

  	  	},

  	  	{

  	  		   lang: 'se',
  	  		   deals: [


						

					    {
					      title: "Norwegian",
					      desc : "Direktflyg tur & retur till Tel Aviv - endast 4½ timme",
					      price : "2,217 SEK",
					      logo: "Deals/se/31.jpg",
					      link:"https://www.norwegian.com/se/bokning/flyg/lagpris/StockholmArlanda-TelAviv#/?origin=ARN&destination=TLV&inbound=2020-01&adults=1&currency=SEK",
					      css_class: "unic-deal-2217",
					      book_now:"BOKA NU"
					    },
					    
					    
					    {
					      title: "Resia",
					      desc : "Weekend i Tel Aviv, flyg + 3 nätter hotell på  mellanklasshotell inkl frukost ",
					      price : "3,332 SEK",
					      logo: "Deals/se/resia.png",
					      link:"https://www.resia.se/flyg-hotell/israel/tel-aviv",
					      css_class: "unic-deal-3332",
					      book_now:"BOKA NU"
					    },

					    {
					      title: "King Tours",
					      desc : "Tel Aviv weekend - 3 nätter på 4 stjärnigt hotell inklusive transfer till/från flygplats",
					      price : "4,200  SEK",
					      logo: "Deals/se/4.jpg",
					      css_class: "unic-deal-4200",
					      link:"https://www.kingtours.se/citibreak-israel",
					      book_now:"BOKA NU"
					    },
					    {
					      title: "Airtours",
					      desc : "Tel Aviv - En trendig stad med vackra strandstränder och nöjen i toppklass. Flyg + hotell i 3 nätter",
					      price : "4,638 SEK",
					      logo: "Deals/se/1.jpg",
					      link:"https://www.airtours.se/israel/tel-aviv/",
					      css_class: "unic-deal-4638",
					      book_now:"BOKA NU"
					    },

					    

					    {
					      title: "Orient Tours",
					      desc : "Tel Aviv weekend 3 nätter på hotell, frukost, transfer och flyg",
					      price : "4,800 SEK",
					      logo: "Deals/se/orienturs.jpg",
					      css_class: "unic-deal-4800",
					      link:"https://www.orienttours.se/tema/storstad/4-dagar-i-tel-aviv/",
					      book_now:"BOKA NU"
					    },
					    {
					        title: "Tel Aviv Hotell",
					        desc : "Upptäck Tel-aviv City Break Gratis middag för två" ,
					        price : "1,200 SEK" ,
					        logo: "Deals/se/tlv-hotels.png" , 
					        css_class: "unic-deal-1200",
					        link : "https://www.visit-tel-aviv.com/en/promotions/telaviv" , 
					        book_now : "BOKA NU"
					    },

					    {
					      title: "Ving",
					      desc : "Weekend i Tel Aviv, 3 nätter, flyg + hotell - inga måltider",
					      price : "4,857 SEK",
					      logo: "Deals/se/31.png",
					      link:"https://www.ving.se/israel/telaviv",
					      css_class: "unic-deal-4857",
					      book_now:"BOKA NU"
					    },

					    {
					      title: "CE Travel",
					      desc : "Direktflyg, 3 nätter på 3* hotell inkl. frukost ",
					      price : "5,240  SEK",
					      logo: "Deals/se/3.png",
					      css_class: "unic-deal-5240",
					      link:"http://www.cetravel.se/travel-offers/tel-aviv/",
					      book_now:"BOKA NU"
					    },
					    

					    {
					      title: "ANA",
					      desc : "2 nätter inklusive frukost på något av våra fina ställen i hela Israel + 3 biljetter till Israels naturparker och -reservat.",
					      price : "810 SEK",
					      logo: "Deals/se/6.jpg",
					      css_class: "unic-deal-810",
					      link:"http://www.iyha.org.il/wp-content/uploads/languages/citybreak.html ",
					      book_now:"BOKA NU"
					    },
					    

					    {
					      title: "Kulturresor Europa",
					      desc : "5 dagar, sv reseledare, stadstur TLV, utflykt till Jerusalem. Direktflyg, transfer, centralt hotell med frukost",
					      price : "11,395 SEK",
					      logo: "Deals/se/kulturresor.png",
					      link:"https://www.kulturresor-europa.se/israel/tel-aviv-city-break",
					      css_class: "unic-deal-11395",
					      book_now:"BOKA NU"
					    },

					    {
					      title: "ÖLVEMARKS HOLIDAY",
					      desc : "Flyg t/r, rundresa med reseledare i Jerusalem & Tel Aviv, 4 nätter på 4-stjärnigt hotell, inkl. frukost + 2 middagar",
					      price : "11,495 SEK",
					      logo: "Deals/se/olvermark.png",
					      link:"https://www.olvemarks.se/jerusalem-och-tel-aviv",
					      css_class: "unic-deal-11495",
					      book_now:"BOKA NU"
					    }
				    ]

  	  	},
  	  	{

  	  		   lang: 'hu',
  	  		   deals: [


						{
							title: "WIZZAIR",
							desc : "Olcsó járatok széles választéka Tel Aviv-ba 18,900 HUF",
							price : "18,900 HUF" ,
							logo: "Deals/hu/26.png" ,
							link : "https://wizzair.com/hu-hu/jaratok/menetrend/budapest/telaviv#/0/0/1/0/0/2018-11/2018-12" ,
							css_class: "unic-deal-111",
							book_now : "Foglalja le most"
						},

						{
					      title : "Ryanair",
					      desc : "Olcsó járatok széles választéka Tel Aviv-ba 18,925 EURO -tól ",
					      price : "18,925 HUF",
					      logo: "Deals/hu/rainer.jpg",
					      link:"https://www.ryanair.com/gb/en/cheap-flights/tel-aviv-to-budapest?out-from-date=2019-07-29&out-to-date=2020-07-29&budget=150",
					      css_class:"unic-deal-18925",
					      book_now:"RÉSERVEZ MAINTENANT"
					    },
						
						{
							title: "El Al",
							desc : "Olcsó járatok széles választéka Tel Aviv-ba 33,300 HUF",
							price : "33,300 HUF" ,
							logo: "Deals/hu/35.jpg" ,
							link : "https://www.elal.com/en/OtherCountries/Pages/default.aspx" ,
							css_class: "unic-deal-222",
							book_now : "Foglalja le most"
						},

						{
							title: "EXPEDIA",
							desc : "Olcsó járatok széles választéka Tel Aviv-ba 33,320 HUF",
							price : "33,320 HUF" ,
							logo: "Deals/hu/25.jpg" ,
							link : "https://www.expedia.com/lp/flights/bud/tlv/budapest-to-tel-aviv" ,
							css_class: "unic-deal-333",
							book_now : "Foglalja le most"
						},

						{
							title: "EXPEDIA",
							desc : "Olcsó járatok széles választéka Tel Aviv-ba 57,670 HUF",
							price : "57,670 HUF" ,
							logo: "Deals/hu/25.jpg" ,
							link : "https://www.expedia.com/Hotel-Search?packageType=fh&c=39c2e2da-2949-4700-b17c-a623cb84a89b&ttla=TLV&ftla=BUD&tripType=ROUND_TRIP&misId=03f5ff56-408c-4e5b-bd0e-eabf2daa8624&origin=Budapest,+Hungary+(BUD-Ferenc+Liszt+Intl.)&destination=Tel+Aviv+(and+vicinity),+Israel&startDate=12/2/2019&endDate=12/5/2019&checkInDate=12/2/2019&checkOutDate=12/5/2019&adults=2&infantsInSeats=0&cabinClass=e&regionId=180031&sort=price&filterSelected=true" ,
							css_class: "unic-deal-444",
							book_now : "Foglalja le most"
						},

						{
							title: "Tel-Aviv Hotels",
							desc : "Tegyen villámlátogtást Tel Aviv városában Ingyenes ebéd két személyre",
							price : "38,000 HUF" ,
							logo: "Deals/hu/tlv-hotels.png" ,
							link : "https://www.visit-tel-aviv.com/en/promotions/telaviv" ,
							css_class: "unic-deal-333",
							book_now : "Foglalja le most"
						}
				    ]

  	  	},
  	  	{

  	  		   lang: 'nl',
  	  		   deals: [


							{
								title: "Oppenheim Travel",
								desc : "Diverse aanbiedingen o.a. 5 sterren Herods hotel aan het strand van Tel Aviv" ,
								price : "€95" ,
								logo  : "Deals/nl/Oppenheim Travel.jpg" , 
								link : "https://www.oppenheim.nl/israel/tel_aviv/herods_tel_aviv/details" , 
								css_class: "unic-class-2",
								book_now : "BOEK NU"
							},
				
							{
								title: "El Al",
								desc : "Israel is Open, Fly EL AL to TLV" ,
								price : "€246" ,
								logo  : "Deals/nl/El Al.jpg" , 
								link : "https://www.elal.com/en/Netherlands/Pages/default.aspx" , 
								css_class: "unic-class-2",
								book_now : "BOEK NU"
							},
							
							{
								title: "Oppenheim Travel",
								desc : "Israël op Wielen, de ideale Fly-drive om het land te leren kennen" ,
								price : "€1159" ,
								logo  : "Deals/nl/Oppenheim Travel.jpg" , 
								link : "https://www.oppenheim.nl/israel/rondreizen/8" , 
								css_class: "unic-class-2",
								book_now : "BOEK NU"
							},
				    ]

  	  	},

  	  	]

  }

  render() {


  	var lang  = localStorage.getItem('currentLang');

  	
  	//  get from  PARAM 



  	const currentLangDeals = this.deals.find((o) => {
  		return o.lang == lang
  	})

  	// console.log('currentLangDeals' , currentLangDeals);
  	const dealsHtml = currentLangDeals.deals.map((o)=>{
  		return <DealItem 
		            key={ o.title } 
  					brand={ o.title } 
  					price={ o.price } 
  					brandImg={ o.logo } 
  					desc={ o.desc } 
  					bookNowLink={o.link}
  					descFontSize={ o.fontSize }
				/>
  	})
    return (
	      <div className="deals-wrapper">
        	<SimpleSlider settings={this.dealsSliderSettings}>
	           {dealsHtml}
          	</SimpleSlider>
	      </div>
    );
  }
}

export default Deals;



// WEBPACK FOOTER //
// ./src/Components/Deals/Deals.js